import React, { useEffect, useState } from 'react';
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

//Import Action
import { filterSort } from '../../../../action';

function ToolBox ( props ) {
  // let layoutParam = "grid";
  const { addClass = "", sort } = props;

  // if ( props.init ) {
  //     layoutParam = props.init;
  // }

  // const [ layout, setLayout ] = useState( layoutParam );

  // const changeLayout = ( e ) => {
  //     e.preventDefault();
  //     props.gridType( e.currentTarget.getAttribute( "title" ) );
  //     setLayout( e.currentTarget.getAttribute( "title" ) );

  //     if ( e.currentTarget.getAttribute( "title" ) === "grid" ) {
  //         props.changeDisplay( 12 );
  //     }

  //     if ( e.currentTarget.getAttribute( "title" ) === "list" ) {
  //         props.changeDisplay( 9 );
  //     }
  // }

  const [sortBy, setSortBy] = useState(sort[0].value);

  useEffect(() => {
    props.filterSort(sortBy);
  }, [sortBy]);

  return (
    <nav className={ "toolbox " + addClass }>
      <div className="toolbox-left">
        <div className="toolbox-item toolbox-sort">
          <label>Sortowanie:</label>

          <div className="select-custom">
            <select name="orderby" className="form-control" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              {sort.map((s, index) => <option value={s.value} key={index}>{s.name}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="toolbox-item toolbox-show">
        <label></label>
      </div>

      {/* <div className="layout-modes">
        <Link to="#" className={ `layout-btn btn-grid ${layout === "grid" ? "active" : ""}` } title="grid" onClick={ changeLayout }>
          <i className="icon-mode-grid"></i>
        </Link>
        <Link to="#" className={ `layout-btn btn-grid ${layout === "list" ? "active" : ""}` } title="list" onClick={ changeLayout }>
          <i className="icon-mode-list"></i>
        </Link>
      </div> */}
    </nav>
  )
}

const mapStateToProps = (state) => {
  return {
    filter: state.filter ? state.filter : ''
  } 
}

export default connect( mapStateToProps, { filterSort } )( ToolBox );